import { render, staticRenderFns } from "./Corporation.vue?vue&type=template&id=ef5b9df4&scoped=true"
import script from "./Corporation.vue?vue&type=script&lang=js"
export * from "./Corporation.vue?vue&type=script&lang=js"
import style0 from "./Corporation.vue?vue&type=style&index=0&id=ef5b9df4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5b9df4",
  null
  
)

export default component.exports